import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKenya = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_148)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 0C7.24242 0 3.13167 2.76867 1.19067 6.78263H22.8092C20.8682 2.76867 16.7574 0 12 0Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C7.24242 24 3.13167 21.2313 1.19067 17.2174H22.8092C20.8682 21.2313 16.7574 24 12 24Z",
				fill: "#496E2D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.4333 8.34782H0.566672C0.199078 9.4995 0 10.7264 0 12C0 13.2735 0.199078 14.5005 0.566672 15.6522H23.4333C23.8009 14.5005 24 13.2735 24 12C24 10.7264 23.8009 9.4995 23.4333 8.34782Z",
				fill: "#A2001D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.7366 5.54536L14.3155 4.88943L11.9999 10.1325L9.68442 4.88943L8.26331 5.54536L11.1381 12L8.26331 18.4546L9.68442 19.1106L11.9999 13.8676L14.3155 19.1106L15.7366 18.4546L12.8618 12L15.7366 5.54536Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.9652 6.16355C12.4151 5.56275 12 5.21738 12 5.21738C12 5.21738 11.5849 5.5627 11.0348 6.16355V17.8364C11.5849 18.4372 12 18.7826 12 18.7826C12 18.7826 12.4151 18.4373 12.9652 17.8364V6.16355Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.39136 8.40202V15.5979C9.9727 16.628 10.6842 17.4723 11.2175 18.0321V5.9679C10.6842 6.52763 9.97265 7.37199 9.39136 8.40202Z",
				fill: "#A2001D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.6087 8.40202C14.0273 7.37194 13.3158 6.52763 12.7826 5.9679V18.0321C13.3158 17.4723 14.0273 16.628 14.6087 15.5979V8.40202Z",
				fill: "#A2001D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.6086 8.40201V15.5979C15.1972 14.555 15.6521 13.3217 15.6521 12C15.6521 10.6783 15.1972 9.44498 14.6086 8.40201Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.39126 8.40201V15.5979C8.80275 14.555 8.34778 13.3217 8.34778 12C8.34778 10.6783 8.80275 9.44498 9.39126 8.40201Z",
				fill: "black"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_148",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgKenya;
